import { useCallback } from 'react';
import { useAutomationRuleFormProvider } from 'src/pages/automation-rule/form';
import { actionTypes } from 'src/pages/automation-rule/form/actions';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import { triggerTypes, useAutomationRuleTrigger } from 'src/pages/automation-rule/form/trigger/use-trigger';
import { randomStringGenerator } from 'src/pages/automation-rule/form/utils/random-string-generator';

export function useSetParentWorkItemToInProgress() {
	const { setTitle } = useAutomationRuleFormProvider();
	const { setTrigger, setTriggerData } = useAutomationRuleTrigger();
	const { setActions} = useAutomationRuleActions();
  
	const setParentWorkItemToInProgress = useCallback(() => {
		setTitle('When any child work item transitions to In Progress, then set the parent work item to In Progress');
		setTrigger(triggerTypes.workItemTransitions);
		setTriggerData({
			workItemTransitions: {
				selectedFrom: ['any'],
				selectedTo: ['In Progress'],
				loading: true,
			},
			workItemIsAssignedTo: null,
			fieldValueChange: null,
			checklistTrigger: null
		});
		setActions([
			{
				id: randomStringGenerator(),
				action: actionTypes.editWorkItem,
				editWorkItem: {
					workItemField: 'System.State',
					relationship: 'parent-work-item',
					inputValueType: 'select',
					selectValue: ['In Progress'],
					textValue: '',
					dateTimeValue: {
						type: 'datetime',
						datetime: {
							value: new Date(),
						},
						timeframe: {
							timeNumber: 0,
							timeUnit: 'minutes',
							timeOption: 'ago',
						},
					},
					userFieldValue: [],
					iterationOrAreaPathValue: '',
					copyFieldValue: '',
					fieldActionValue: 'set-value'
				},
				addCommentToWorkItem: null,
				sendNotificationToSlack: null,
				sendEmailNotification: null,
				sendTeamsNotification: null,
				createdAt: new Date()
			},
		]);
	}, []);
  
	return {
		setParentWorkItemToInProgress,
	};
}